export default __webpack_public_path__ + "static/media/NotoSansKR-Medium.7def03a7.otf";